// override original https://github.com/date-fns/date-fns/blob/4544f0cb1d724bfa7ee846b762bacb8fc303a961/src/locale/en-US/_lib/formatDistance/index.js
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: '1s',
    other: '{{count}} seconds',
  },

  xSeconds: {
    one: '1s',
    other: '{{count}}s',
  },

  halfAMinute: '30s',

  lessThanXMinutes: {
    one: '1 minute',
    other: '{{count}} minutes',
  },

  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes',
  },

  aboutXHours: {
    one: '1 hour',
    other: '{{count}} hours',
  },

  xHours: {
    one: '1 hour',
    other: '{{count}} hours',
  },

  xDays: {
    one: '1 day',
    other: '{{count}} days',
  },

  aboutXWeeks: {
    one: '1 week',
    other: '{{count}} weeks',
  },

  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks',
  },

  aboutXMonths: {
    one: '1 month',
    other: '{{count}} months',
  },

  xMonths: {
    one: '1 month',
    other: '{{count}} months',
  },

  aboutXYears: {
    one: '1 year',
    other: '{{count}} years',
  },

  xYears: {
    one: '1 year',
    other: '{{count}} years',
  },

  overXYears: {
    one: '1 year',
    other: '{{count}} years',
  },

  almostXYears: {
    one: '1 year',
    other: '{{count}} years',
  },
};

interface FormatDistanceOptions {
  addSuffix?: boolean;
  comparison?: number;
}

export function formatDistanceEn(
  token: keyof typeof formatDistanceLocale,
  count: number,
  options: FormatDistanceOptions = {},
) {
  const { addSuffix, comparison } = options;

  const distanceLocale = formatDistanceLocale[token];

  let result;
  if (typeof distanceLocale === 'string') {
    result = formatDistanceLocale[token];
  } else if (distanceLocale?.one && count === 1) {
    result = distanceLocale.one;
  } else {
    result = distanceLocale.other.replace('{{count}}', count.toString());
  }

  if (addSuffix) {
    if (typeof comparison === 'number' && comparison > 0) {
      return `in ${result}`;
    }
    return `${result} ago`;
  }

  return result;
}
